export default {
  'userPendingChanges.title': 'Changes Awaiting Approval',
  'userPendingChanges.logMessage': 'Changes awaiting for approval for <%=userName%>',
  'userPendingChanges.reject.message':
    'Rejecting user will purge all permission records. Do you wish to proceed?'
};
